import { render, staticRenderFns } from "./lecturer.vue?vue&type=template&id=b14da92a&scoped=true"
import script from "./lecturer.vue?vue&type=script&lang=js"
export * from "./lecturer.vue?vue&type=script&lang=js"
import style0 from "./lecturer.vue?vue&type=style&index=0&id=b14da92a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b14da92a",
  null
  
)

export default component.exports